<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-2.着色器 顶点着色器-轨道控制器</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import * as dat from 'dat.gui'; 
import {generateScene} from '@/threejsEnv/scene.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {generateShader} from './components/shader';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';

export default {
  data(){
    return {
      scene:null,
      camera:null, 
      renderer:null, 
      points:null,
      u_time:0,
      gui:null,
      control: null,
      animationId: null, // 新增这一行
      guiParams: {
        pointer: true 
      },
      window:{
        width: 0,
        height: 0
      }
    }
  },
  mounted(){
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;

    this.scene = generateScene();
    
    this.camera = genPerspectiveCamera(this.window)

    this.renderer = genRenderer(this.window)

    this.control  = new OrbitControls(this.camera, this.renderer.domElement); 
    this.control.enableDamping = true; 
    this.control.dampingFactor = 0.1;

    this.$refs.container.appendChild(this.renderer.domElement);

    this.initGUI();
    this.initPanel();
    this.render();
    //添加监听
    window.addEventListener('resize', this.onWindowResize);
  },
  methods:{
    initPanel(){
      const planeGeometry = new THREE.PlaneGeometry(5, 5, 80, 80);
      const shaderMaterial = generateShader();
      
      this.points = new THREE.Points(planeGeometry, shaderMaterial);

      // 5. 【关键】将 Points 对象也进行同样的旋转，使其与平面完全重合
      this.points.rotation.x = -Math.PI / 2.0;

      // 6. 将 Points 对象添加到场景中
      this.scene.add(this.points);
    },
    render() {
      this.animationId = requestAnimationFrame(this.render); 
      this.renderer.render(this.scene, this.camera);
			this.points.rotation.z -= 0.001;
      this.u_time+=0.02;
      this.points.material.uniforms.u_time.value = this.u_time;
      this.control.update();
    },
    initGUI(){
      this.gui = new dat.GUI(); 
      this.gui.open();//默认打开面版
      this.gui.add(this.guiParams, 'pointer')
          .name('启用通道1') // 控制器的标签
          .onChange((value) => {
               console.log(value);
          });
      this.gui.add(this.guiParams, 'pointer')
          .name('启用通道2') // 控制器的标签
          .onChange((value) => {
               console.log(value);
          });
    },
    onWindowResize(){
        const container = this.$refs.container;
        const width = container.clientWidth;
        const height = container.clientHeight;

        // 1. 更新相机的宽高比 (aspect)
        this.camera.aspect = width / height;
        // 【关键】更新相机的投影矩阵，使更改生效
        this.camera.updateProjectionMatrix();

        // 2. 更新渲染器的尺寸
        this.renderer.setSize(width, height);
    }
  },
  beforeDestroy(){
    cancelAnimationFrame(this.animationId);
    this.gui.destroy();
    this.points.geometry.dispose(); // 释放几何体内存
    this.points.material.dispose(); // 释放材质内存
    this.scene.remove(this.points); // 从场景中移除模型
    this.renderer.domElement.remove(); // 从 DOM 中移除 canvas 元素
    this.renderer.dispose(); // 释放渲染器内存
  },
  destroyed(){
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.points = null;
    this.gui=null;
  }
}
</script>

<style scoped>

</style>